import { phoneFormatter } from 'merchant/services/Helper.service';

declare global {
  interface Window {
    smartech: any;
  }
}

let analyticsPixelObj;
let shopifyCustomerId;

const cartItems = (cart) => {
  let items = [];
  const host = `https://${window.location.hostname}`;
  cart.map((itm) => {
    items.push({
      produrl: `${host}${itm.url}`,
      prid: itm.variant_id,
      name: itm.product_title,
      price: itm.price / 100,
      prqt: itm.quantity,
      variant: itm.variant_title,
      image: itm.image,
      currency: 'INR',
      brand: itm.vendor,
    });
  });
  return items;
};

export const callNetcore = (eventName, data) => {
  analyticsPixelObj = data?.analyticsPixelObj;
  shopifyCustomerId = data?.shopifyCustomerId;
  if (eventName === 'mobileAddedGK') {
    netcoreMobile(data);
  } else if (eventName === 'pinCode') {
    netcorePincode(data);
  } else if (eventName === 'paymentMethod') {
    netcorePaymentMethod(data);
  } else if (eventName === 'paymentCompleted') {
    netcorePaymentCompleted(data);
  } else if (eventName === 'userAddress') {
    netcoreAddressAdded(data);
    netcoreCustomCheckout(data);
  }
};

const netcoreMobile = (data) => {
  let dataObj = {
    eventName: 'mobile_added_gk',
    data: {
      amount: data.commonAnalyticsData.cart_total_price,
      currency: data.commonAnalyticsData.currency,
      mobile: data.evt.phoneNumber,
      promo_code: data.commonAnalyticsData?.coupon || '',
      tag: 'GoKwik',
      items: cartItems(data.cart.items),
      abc_url: data.abcURL,
    },
  };
  netcoreSendEvent(dataObj.eventName, dataObj.data);
};

const netcorePincode = (data) => {
  let dataObj = {
    eventName: 'pin_code_added_gk',
    data: {
      amount: data.commonAnalyticsData.cart_total_price,
      currency: data.commonAnalyticsData.currency,
      mobile: data.phoneNumber,
      ZIP: `${data.evt.pincode}`,
      promo_code: data.commonAnalyticsData?.coupon || '',
      tag: 'GoKwik',
      items: cartItems(data.cart.items),
    },
  };
  netcoreSendEvent(dataObj.eventName, dataObj.data);
};

const netcoreAddressAdded = (data) => {
  let dataObj = {
    eventName: 'address_selected_gk',
    data: {
      first_name: data.userAddress?.firstname,
      last_name: data.userAddress?.lastname,
      email: data.userAddress?.email,
      full_address: data.userAddress?.address,
      city: data.userAddress?.city,
      state: data.userAddress?.state,
      address_type: data.userAddress?.addresstype,
      ZIP: `${data.userAddress?.pincode}`,
      shipping_method: data.shippingMethod || 'Standard',
      abc_url: `${data.merchantUrl}?mrid=${data.request_id}`,
      amount: data.commonAnalyticsData.cart_total_price,
      currency: data.commonAnalyticsData.currency,
      mobile: data.phoneNumber,
      promo_code: data?.commonAnalyticsData?.coupon || '',
      tag: 'GoKwik',
      items: cartItems(data.cart.items),
      user_type: data.user_type,
    },
  };
  netcoreSendEvent(dataObj.eventName, dataObj.data, data.userAddress?.email);
};

const netcorePaymentMethod = (data) => {
  let dataObj = {
    eventName: 'payment_method_selected_gk',
    data: {
      'payment method': data.evt.paymentMethod,
      first_name: data.userAddress?.firstname,
      last_name: data.userAddress?.lastname,
      email: data.userAddress?.email,
      full_address: data.userAddress?.address,
      city: data.userAddress?.city,
      state: data.userAddress?.state,
      address_type: data.userAddress?.addresstype,
      ZIP: `${data.userAddress?.pincode}`,
      shipping_method: data.shippingMethod || 'Standard',
      abc_url: data.abcURL,
      amount: data.commonAnalyticsData.cart_total_price,
      currency: data.commonAnalyticsData.currency,
      mobile: data.phoneNumber,
      promo_code: data?.commonAnalyticsData?.coupon || '',
      tag: 'GoKwik',
      items: cartItems(data.cart.items),
    },
  };
  netcoreSendEvent(dataObj.eventName, dataObj.data, data.userAddress?.email);
};

const netcorePaymentCompleted = (data) => {
  let dataObj = {
    eventName: 'payment_complete_gk',
    data: {
      'payment method': data.paymentMethod,
      first_name: data.userAddress?.firstname,
      last_name: data.userAddress?.lastname,
      email: data.userAddress?.email,
      full_address: data.userAddress?.address,
      city: data.userAddress?.city,
      state: data.userAddress?.state,
      address_type: data.userAddress?.addresstype,
      ZIP: `${data.userAddress?.pincode}`,
      shipping_method: data.shippingMethod || 'Standard',
      amount: data.commonAnalyticsData.cart_total_price,
      currency: data.commonAnalyticsData.currency,
      mobile: data.phoneNumber,
      promo_code: data.commonAnalyticsData?.coupon || '',
      tag: 'GoKwik',
      items: cartItems(data.cart.items),
    },
  };
  netcoreSendEvent(dataObj.eventName, dataObj.data, data.userAddress?.email);
};

const netcoreCustomCheckout = (data) => {
  let dataObj = {
    eventName: 'custom checkout',
    data: {
      Item_count: data.cart.item_count,
      Total_price: data.cart.total_price,
      currency: data.cart.currency,
      items: cartItems(data.cart.items),
    },
  };
  netcoreSendEvent(dataObj.eventName, dataObj.data, data.userAddress?.email);
};

const netcoreSendEvent = (event, data, email?) => {
  let smarTechData = {
    mobile: data?.mobile,
    FIRST_NAME: data?.first_name,
    CITY: data?.city,
    ZIP: data?.ZIP,
    STATE: data?.state,
  };
  const formatedNumber = phoneFormatter(data?.mobile, analyticsPixelObj?.netcore);

  if (analyticsPixelObj?.netcore?.value === 'phone') {
    smarTechData['pk^mobile'] = formatedNumber;
  } else if (analyticsPixelObj?.netcore?.value == 'customer_id') {
    delete smarTechData['pk^mobile'];
    smarTechData['pk^custid'] = shopifyCustomerId;
  } else {
    delete smarTechData['pk^mobile'];
    delete smarTechData['pk^custid'];
    smarTechData['pk^email'] = email;
  }
  //@ts-ignore
  smartech('contact', 100, smarTechData);
  if (analyticsPixelObj?.netcore?.value == 'phone') {
    //@ts-ignore
    smartech('identify', formatedNumber);
  } else if (analyticsPixelObj?.netcore?.value == 'customer_id') {
    //@ts-ignore
    smartech('identify', shopifyCustomerId);
  } else {
    // @ts-ignore
    email && smartech('identify', email);
  }
  //@ts-ignore
  smartech('dispatch', event, data);
};
